<script>
  import { format } from 'svelte-i18n';
  import { Alert, Input } from '@sveltestrap/sveltestrap';

  export let config = {};
  export let updating = false;
  export let error = '';
  export let onKeyUp = () => {};
</script>

<div class="create-form">
  {#if error}
    <Alert color="danger">{@html error}</Alert>
  {/if}

  <p>{$format('label.DOMAIN')}</p>
  <Input
    type="text"
    bind:value={config.domainName}
    disabled={updating}
    on:keyup={onKeyUp}
    placeholder={$format('label.PLACEHOLDER.DOMAIN')}
  />

  <p>{$format('label.ADMIN_EMAIL')}</p>
  <Input
    type="text"
    bind:value={config.adminEmail}
    disabled={updating}
    on:keyup={onKeyUp}
    placeholder={$format('label.PLACEHOLDER.ADMIN_EMAIL')}
  />

  <p>{$format('label.AUTH_CODE')}</p>
  <Input
    type="password"
    bind:value={config.authCode}
    disabled={updating}
    on:keyup={onKeyUp}
    placeholder={$format('label.PLACEHOLDER.AUTH_CODE')}
  />

  <br />

  <Input
    type="checkbox"
    bind:checked={config.allowClone}
    class="unlock-clone"
    disabled={updating}
    label={$format('label.DOMAIN_UNLOCKED_CLONING')}
  />
</div>

<style lang="scss" src="./create-form.scss"></style>
